import { render, staticRenderFns } from "./oomHomeSlider.vue?vue&type=template&id=3ee580c1&scoped=true"
import script from "./oomHomeSlider.vue?vue&type=script&lang=js"
export * from "./oomHomeSlider.vue?vue&type=script&lang=js"
import style0 from "./oomHomeSlider.vue?vue&type=style&index=0&id=3ee580c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee580c1",
  null
  
)

export default component.exports